import { z } from 'zod';
import { defineEndpoint } from '../define';

/**
 * Sign in with Slack account linking (UCH-805). The web navigates the browser
 * to `url`; Slack redirects to the API's unauthenticated callback, which
 * bounces code + state to `/profile/settings?slack_code=…&slack_state=…`;
 * the web then completes the link with `linkSlack` as the signed-in user.
 */
export const startSlackLink = defineEndpoint({
  method: 'POST',
  path: '/v1/auth/slack/link-start',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: z.object({ url: z.string().url() }) }),
});

/** 409 when the state is expired, forged, or minted for another user. */
export const linkSlack = defineEndpoint({
  method: 'POST',
  path: '/v1/auth/slack/link',
  params: z.object({}),
  query: z.object({}),
  body: z.object({ code: z.string().min(1), state: z.string().min(1) }),
  response: z.object({
    data: z.object({ outcome: z.enum(['linked', 'taken', 'wrong_workspace']) }),
  }),
});

export const unlinkSlack = defineEndpoint({
  method: 'DELETE',
  path: '/v1/auth/slack',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: z.undefined(),
  successStatus: 204,
});
